import { render } from "./Tasks.vue?vue&type=template&id=2d2bb80d"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Organisation/Partials/Tasks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d2bb80d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d2bb80d', __exports__)) {
    console.log('reload')
    api.reload('2d2bb80d', __exports__)
  }
  
  module.hot.accept("./Tasks.vue?vue&type=template&id=2d2bb80d", () => {
    console.log('re-render')
    api.rerender('2d2bb80d', render)
  })

}


export default __exports__